import { FooterList } from 'components/footer/footer-list';
import Link from 'next/link';
import React from 'react';
import { NoFollowLink } from 'shared/no-follow-link';
import { getAssetPath } from 'utils/asset-utils';
import { getBlogUrl, getFrontEndUrl } from 'utils/environment-util';

const SHEF_LOGO_PATH = getAssetPath('/images/shef-logo.svg');
const APP_STORE_LINK_PATH = getAssetPath('/images/app-store-link.svg');
const GOOGLE_PLAY_LINK_PATH = getAssetPath('/images/google-play-link.svg');

const GOOGLE_PLAY_HREF = 'https://play.google.com/store/apps/details?id=com.shef.consumerapp&hl=en_US&gl=US&pli=1';
const APP_STORE_HREF = 'https://apps.apple.com/us/app/shef-homemade-food-delivery/id1598007796';

interface IProps {
  className?: string;
}

export const Footer: React.FC<IProps> = ({ className }) => {
  const frontEndUrl = getFrontEndUrl();
  const blogUrl = getBlogUrl();
  return (
    <div className={`flex w-full flex-col bg-neutral-50 p-10 ${className} `}>
      <div className='flex flex-col pb-5 md:flex-row'>
        <NoFollowLink className='mb-6 flex grow flex-col items-center md:mb-0 md:items-start' href={frontEndUrl}>
          <img src={SHEF_LOGO_PATH} alt='Shef Logo' className='mb-8 h-10 w-[100px]' />
        </NoFollowLink>
        <FooterList title='Learn'>
          <NoFollowLink href={`${blogUrl}/our-story`}>Our Story</NoFollowLink>
          <Link href={`${frontEndUrl}/homemade-food/food-safety`} className='hover:text-[Colors.KOHLRABI]'>
            Food Safety
          </Link>
          <NoFollowLink href='https://help.shef.com/en/'>Help Center</NoFollowLink>
          <Link href={`${frontEndUrl}/homemade-food`} className='hover:text-[Colors.KOHLRABI]'>
            Global Cuisines
          </Link>
        </FooterList>
        <FooterList title='Community'>
          <Link href={`${frontEndUrl}/homemade-food/blog/`} className='hover:text-[Colors.KOHLRABI]'>
            Blog
          </Link>
          <NoFollowLink href='https://www.facebook.com/ordershef'>Facebook</NoFollowLink>
          <NoFollowLink href='https://www.instagram.com/ordershef'>Instagram</NoFollowLink>
          <NoFollowLink href='https://www.tiktok.com/@ordershef'>TikTok</NoFollowLink>
        </FooterList>
        <FooterList title='Resources'>
          <NoFollowLink href={`${frontEndUrl}/become-a-shef`}>Become a shef</NoFollowLink>
          <NoFollowLink href={`${frontEndUrl}/careers`}>Careers</NoFollowLink>
          <NoFollowLink href={`${frontEndUrl}/gift`}>Gift cards</NoFollowLink>
          <Link href='/' className='hover:text-[Colors.KOHLRABI]'>
            Homemade food delivery
          </Link>
        </FooterList>
      </div>
      <div className='flex flex-col justify-between gap-4 border-t border-neutral-200 pt-5 text-xs font-normal text-neutral-700 md:flex-row md:gap-0'>
        <div className='flex grow flex-col items-center gap-4 md:flex-row md:gap-10'>
          <NoFollowLink href={`${frontEndUrl}/privacy-policy`}>Privacy Policy</NoFollowLink>
          <NoFollowLink href={`${frontEndUrl}/terms-of-service`}>Terms of Service</NoFollowLink>
        </div>
        <div className='flex flex-col items-center gap-4 md:flex-row'>
          <span>
            <i className='far fa-copyright mr-1' /> Shef, Inc. 2024. All Rights Reserved.
          </span>
          <div className='flex w-fit flex-row gap-4'>
            <NoFollowLink href={APP_STORE_HREF}>
              <img src={APP_STORE_LINK_PATH} width='92' height='33' alt='Download on the App Store' />
            </NoFollowLink>
            <NoFollowLink href={GOOGLE_PLAY_HREF}>
              <img src={GOOGLE_PLAY_LINK_PATH} width='108' height='33' alt='Get it on Google Play' />
            </NoFollowLink>
          </div>
        </div>
      </div>
    </div>
  );
};
